import React from 'react'

import PropTypes from 'prop-types'

import IconBase, { Circle } from '../IconBase/IconBase'
function UnChecked({
  color = 'white',
  strokeColor = 'icon.primary',
  ...props
}) {
  return (
    <IconBase viewBox='0 0 34 34' {...props}>
      <Circle
        cx='17'
        cy='17'
        r='16'
        stroke={strokeColor}
        fill={color}
        strokeWidth='2'
      />
    </IconBase>
  )
}
UnChecked.propTypes = {
  color: PropTypes.string,
  strokeColor: PropTypes.string,
}
export default UnChecked
